import { RolesEnum } from "src/app/features/tests/features/constants";
import { Action, Subject } from "../../services/ability/ability.type";

/**
 * `action` defaults to view. A link that needs more than seeing its subject —
 * shipping, which every role can "view" through Viewer's blanket grant — names
 * the action it needs.
 */
export const SIDEBAR_LINKS: Array<{
  icon: string;
  link: string;
  title: string;
  groups: string[];
  ability: Subject;
  action?: Action;
  showOnlyForRoles?: RolesEnum[];
  hideForRoles?: RolesEnum[];
}> = [
    {
      icon: 'dashboard',
      link: '/dashboard',
      title: 'dashboard',
      groups: ['/dashboard'],
      ability: Subject.DashboardPage,
    },
    {
      icon: 'medical_information',
      link: '/physician-dashboard',
      title: 'physician',
      groups: ['/physician-dashboard'],
      ability: Subject.PhysicianDashboardPage,
      showOnlyForRoles: [RolesEnum.SharedPhysician],
    },
    {
      icon: 'groups',
      link: '/patients',
      title: 'patients',
      groups: ['/patients'],
      ability: Subject.PatientsPage,
    },
    {
      icon: 'assignment',
      link: '/tests',
      title: 'tests',
      groups: ['/tests', '/working-area', '/live-tests'],
      ability: Subject.TestsPage,
    },
    {
      icon: 'speaker',
      link: '/devices',
      title: 'devices',
      groups: ['/devices'],
      ability: Subject.DevicesPage,
    },
    {
      icon: 'monitoring',
      link: '/statistics',
      title: 'statistics',
      groups: ['/statistics'],
      ability: Subject.ReportsPage,
      hideForRoles: [RolesEnum.SharedPhysician],
    },
    {
      icon: 'settings',
      link: '/settings',
      title: 'settings',
      groups: ['/settings'],
      ability: Subject.SettingsPage,
    },
  ]
